import React, { createContext, useContext, useState } from "react";

import { NewOrderRepository } from "../../repository/AdminDashboard/Order_repository";
import { OrderRepository } from "../../repository/AdminDashboard/Order_repository";
import toast, { Toaster } from "react-hot-toast";
import OrderList from "../../components/orderpage/OrderList";

const StateContext = createContext();
const initialState = {
  NewOrder: [],
  order: [],

  edit: {
    status: "",
    code: "",
  },
};
const OrderContext = ({ children }) => {
  const [modaldata, setmodaldata] = useState({});
  const [codeval, setcodeval] = useState("");
  const [NewOrderList, setNewOrderList] = useState(initialState.NewOrder);
  const [orderList, setorderList] = useState(initialState.order);
  const [tableNewOrderLoaded, settableNewOrderLoaded] = useState(false);
  const [tableorderloaded, settableorderloaded] = useState(false);
  const [text, settext] = useState("");
  const [textorder, settextorder] = useState("");
  const [pageNumber, setpageNumber] = useState(0);
  const [countAllPages, setCountAllPages] = useState(10);
  const [countallorder, setcountallorder] = useState(10);
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [showDeleteModalNew, setshowDeleteModalNew] = useState(false);
  const [id, setid] = useState("");
  const [name, setname] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [newmodal, setnewmodal] = useState(false);
  const [status, setstatus] = useState(initialState.edit.status);
  const [code, setcode] = useState(initialState.edit.code);
  const [disable, setdisable] = useState(true);

  // new order
  const getnewOrder = async (edit) => {
    settableNewOrderLoaded(true);
    const newOrderList_data = await NewOrderRepository.getNewOrder(text, edit);
    setNewOrderList(newOrderList_data.neworderList);
    setCountAllPages(newOrderList_data.countAllPages);
    setcodeval(newOrderList_data.code);
    settableNewOrderLoaded(false);
  };

  // order list
  const getOrder = async (edit) => {
    settableorderloaded(true);
    const orderList_data = await OrderRepository.getOrder(
      textorder,
      pageNumber,
      edit
    );
    setorderList(orderList_data.orderList);
    setcountallorder(orderList_data.countAll);
    settableorderloaded(false);
  };

  // get new order delete
  const getDeleteNewOrder = async (id) => {
    settableNewOrderLoaded(true);
    const NewOrde_data = await NewOrderRepository.deleteorder(id);
    if (NewOrde_data.code == 1) {
      const Newnewlist = NewOrderList.filter((item) => {
        return item.id !== id;
      });
      toast.success(NewOrde_data.massage, {
        className: "text-12 text-dark-blue-200",
      });
      // console.log(id);
      setNewOrderList(Newnewlist);
      await getOrder();
    } else if (NewOrde_data.code == 0) {
      return (
        NewOrderList,
        toast.error(NewOrde_data.massage, {
          className: "text-12 text-dark-blue-200",
        })
      );
    }
    settableNewOrderLoaded(false);
  };

  // get delete order list
  const getDeleteOrder = async (id) => {
    settableorderloaded(true);
    const Order_data = await OrderRepository.deleteorder(id);
    if (Order_data.code == 1) {
      const New_OrderList = orderList.filter((item) => {
        return item.id !== id;
      });
      toast.success(Order_data.massage, {
        className: "text-12 text-dark-blue-200",
      });
      setorderList(New_OrderList);
    } else if (Order_data.code == 0) {
      return (
        orderList,
        toast.error(Order_data.massage, {
          className: "text-12 text-dark-blue-200",
        })
      );
    }
    settableorderloaded(false);
  };

  // search new order
  const buttonSearch = async (e) => {
    e.preventDefault();
    await getnewOrder();
  };

  const gettext = (e) => {
    const tex = e.target.value;
    settext(tex);
  };
  // search order
  const buttonordersearch = async (e) => {
    e.preventDefault();
    await getOrder();
  };

  const getorderText = (e) => {
    const tex = e.target.value;
    settextorder(tex);
  };
  // pagination
  const changePage = async ({ selected }) => {
    settableorderloaded(true);
    // console.log(selected);
    setpageNumber(selected);
    await getOrder();
    settableorderloaded(false);
  };
  // delete neworder
  const ondelete = (event) => {
    const id = event.currentTarget.getAttribute("data-attr");
    setname(NewOrderList[id - 1].orderNumber);
    // console.log(NewOrderList)
    setid(id);
    setshowDeleteModalNew(true);
  };

  const closeDeleteModalnew = () => {
    setshowDeleteModalNew(false);
  };

  const RemoveItemnew = async () => {
    setshowDeleteModalNew(false);
    await getDeleteNewOrder(id);
  };
  //  delet order
  const ondeleteorder = (event) => {
    const id = event.currentTarget.getAttribute("data-attr");
    // console.log(orderList)
    setname(orderList[id - 1].orderNumber);
    setid(id);
    setshowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setshowDeleteModal(false);
  };

  const RemoveItem = async () => {
    setshowDeleteModal(false);
    await getDeleteOrder(id);
  };

  const onediteNeworde = (event) => {
    // console.log("new")
    // setnewcall(true)
    setnewmodal(true);
    const id = event.currentTarget.getAttribute("data-attr");
    const indexOfOrder = NewOrderList.findIndex((a) => {
      return a.getId() == id;
    });
    // console.log(NewOrderList[0]);
    setmodaldata(NewOrderList[indexOfOrder]);

    if (NewOrderList[indexOfOrder].status == "تحویل پست شده") {
      // console.log("dis")
      setdisable(false);
    } else {
      setdisable(true);
    }
  };

  const onedite = (event) => {
    setshowModal(true);
    const id = event.currentTarget.getAttribute("data-attr");
    // console.log(orderList)
    const indexOfOrder = orderList.findIndex((a) => {
      return a.getId() == id;
    });
    // console.log(orderList[indexOfOrder].status)
    setmodaldata(orderList[indexOfOrder]);
    if (orderList[indexOfOrder].status === "تحویل پست شده") {
      // console.log("dis")
      setdisable(false);
    } else {
      setdisable(true);
    }
  };

  const closeModal = () => {
    setshowModal(false);
    setnewmodal(false);
    setstatus("");
    setcode("");
    // setnewcall(false)
  };
  // selectbox
  const changestatus = (event) => {
    if (event.length > 0) {
      setstatus(event[0].value);
      // setmodaldata({...modaldata})
    }
    if (event[0] != undefined) {
      if (event[0].value === "تحویل پست شده") {
        // console.log("dis")
        setdisable(false);
      } else if (event[0].value != "تحویل پست شده") {
        setdisable(true);
      }
    }
  };

  // handlechange input
  const onchangeInput = (event) => {
    setcode(event.target.value);
  };
  //  done edit new order
  const doneEditNewOrder = async () => {
    if (initialState.edit.status.length > 0) {
      setnewmodal(false);
      // console.log(initialState.edit);
      await getnewOrder(initialState.edit);
      setstatus("");
      setcode("");
    } else if (initialState.edit.status.length === 0) {
      toast.error("وضعیت سفارش را انتخاب کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
  };

  const doneEditorder = async () => {
    if (initialState.edit.status.length > 0) {
      // console.log("List");
      setshowModal(false);
      // console.log(initialState.edit)
      await getOrder(initialState.edit);
      setstatus("");
      setcode("");
    } else if (initialState.edit.status.length === 0) {
      toast.error("وضعیت سفارش را انتخاب کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
  };
  //  done edit orderList
  initialState.edit.status = status;
  initialState.edit.code = code;

  return (
    <StateContext.Provider
      value={{
        NewOrderList,
        tableNewOrderLoaded,
        countAllPages,
        getnewOrder,
        changePage,
        onedite,
        ondeleteorder,
        ondelete,
        orderList,
        tableorderloaded,
        getOrder,
        gettext,
        buttonSearch,
        getorderText,
        pageNumber,
        buttonordersearch,
        showDeleteModal,
        closeDeleteModal,
        RemoveItem,
        name,
        closeDeleteModalnew,
        RemoveItemnew,
        showModal,
        closeModal,
        onediteNeworde,
        modaldata,
        codeval,
        doneEditNewOrder,
        doneEditorder,
        newmodal,
        changestatus,
        onchangeInput,
        disable,
        countallorder,
        showDeleteModalNew,
        // newcall
      }}>
      {children}
    </StateContext.Provider>
  );
};

function OrderUseContext() {
  return React.useContext(StateContext);
}

export { OrderUseContext };
export default OrderContext;
